import React from 'react';

import BeforeClaimSection from './components/BeforeClaimSection';
import CaptionedImageSection from './components/CaptionedImageSection';
import FAQSection from './components/FAQSection';
import FileAClaim from './components/FileAClaim';
import GuaranteeServiceDescription from './components/GuaranteeServiceDescription';
import MoreDetailsSection from './components/MoreDetailsSection';
import WhoIsRoverForSection from './components/WhoIsRoverForSection';

const GuaranteePage = (): JSX.Element => (
  <>
    <GuaranteeServiceDescription />
    <CaptionedImageSection />
    <WhoIsRoverForSection />
    <MoreDetailsSection />
    <FileAClaim />
    <BeforeClaimSection />
    <FAQSection />
  </>
);

export default GuaranteePage;
